import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../../../pure-js/types/User'
import { User as FirebaseUser } from 'firebase/auth'

interface AuthState {
  user: User | null
  firebaseUser: FirebaseUser | null
  isAuthenticated: boolean
  isAuthInitialized: boolean
}

const initialState: AuthState = {
  user: null,
  firebaseUser: null,
  isAuthenticated: false,
  isAuthInitialized: false
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload
      state.isAuthenticated = action.payload !== null
    },
    setFirebaseUser: (state, action: PayloadAction<FirebaseUser | null>) => {
      state.firebaseUser = action.payload
    },
    setAuthInitialized: (state, action: PayloadAction<boolean>) => {
      state.isAuthInitialized = action.payload
    },
    clearAuth: (state) => {
      state.user = null
      state.firebaseUser = null
      state.isAuthenticated = false
    }
  }
})

export const { setUser, setFirebaseUser, setAuthInitialized, clearAuth } = authSlice.actions
export default authSlice.reducer
